import React from "react";
import { Provider } from "react-redux";
import store from "store";
import WidgetbarForm from "components/administration/widgetbar/WidgetbarForm";

function WidgetbarEdit(props: any) {
  return (
    <Provider store={store}>
      <div className="edit-widgetbar">
        <WidgetbarForm {...props} />
      </div>
    </Provider>
  );
}

export default WidgetbarEdit;
